/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type Tile_item$ref = any;
export type SharedItemTile_item$ref = any;
export type SharedItemTile_item = {
    readonly serviceId: string | null;
    readonly title: string | null;
    readonly measurement: {
        readonly dimensions: ReadonlyArray<{
            readonly unit: string | null;
            readonly value: string | null;
        } | null> | null;
        readonly size: {
            readonly value: string | null;
        } | null;
    } | null;
    readonly browseUrl: string | null;
    readonly categoryCode: string | null;
    readonly " $fragmentRefs": Tile_item$ref;
    readonly " $refType": SharedItemTile_item$ref;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "value",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SharedItemTile_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "showSeller",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "measurement",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": "dimensions",
          "name": "display",
          "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\"],separator:\" \")",
          "args": [
            {
              "kind": "Literal",
              "name": "addLabel",
              "value": true
            },
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "height",
                "width",
                "depth",
                "diameter"
              ]
            },
            {
              "kind": "Literal",
              "name": "separator",
              "value": " "
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "unit",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "size",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemSize",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "browseUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Tile_item",
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ]
    }
  ]
};
})();
(node as any).hash = '94dc37ed09bb3825b46a5ab8b41f0e9e';
export default node;
